import axios from '@/libs/api.request'
const face = {
    getDeptList: () => {
        return axios.get({
            url: '/Dept/DeptFaceList'
        })
    },
    getFaceData: (data) => {
        return axios.get({
            url: '/Face?' + axios.parseParams(data)
        })
    }
}
export default face


// WEBPACK FOOTER //
// ./src/api/api-face.js